<template>
  <!-- household -->
  <div class="house-table">
    <dl class="popup-population-wrapper">
      <dt class="popup-population-range">
        {{ `${circleRange}m圏内世帯数` }}
      </dt>
      <dd class="popup-population-total">{{ existInfo ? this.calcInfo.total : '...' }}</dd>
    </dl>
    <div class="houseTable-wrapper">
    <table class=houseTable>
      <tbody>
      <tr class="column">
        <td class="year"></td><td>計</td><td>％</td>
      </tr>
      <tr class="new_type_1">
        <td class="column">第1類型</td>
        <td class="column">{{ existInfo ? info.new_type_1 || 0  : '...' }}</td>
        <td class="column">{{ existInfo ? this.calcInfo.percentage[0] : '...' }}</td>
      </tr>
      <tr class="new_type_2">
        <td class="column">第2類型</td>
        <td class="column">{{ existInfo ? info.new_type_2 || 0 : '...' }}</td>
        <td class="column">{{ existInfo ? this.calcInfo.percentage[1] : '...' }}</td>
      </tr>
      <tr class="new_type_3">
        <td class="column">第3類型</td>
        <td class="column">{{ existInfo ? info.new_type_3 || 0 : '...' }}</td>
        <td class="column">{{ existInfo ? this.calcInfo.percentage[2] : '...' }}</td>
      </tr>
      <tr class="new_type_4">
        <td class="column">第4類型</td>
        <td class="column">{{ existInfo ? info.new_type_4 || 0 : '...' }}</td>
        <td class="column">{{ existInfo ? this.calcInfo.percentage[3] : '...' }}</td>
      </tr>
      <tr class="new_type_5">
        <td class="column">第5類型</td>
        <td class="column">{{ existInfo ? info.new_type_5 || 0 : '...' }}</td>
        <td class="column">{{ existInfo ? this.calcInfo.percentage[4] : '...' }}</td>
      </tr>
      <tr class="new_type_6">
        <td class="column">第6類型</td>
        <td class="column">{{ existInfo ? info.new_type_6 || 0 : '...' }}</td>
        <td class="column">{{ existInfo ? this.calcInfo.percentage[5] : '...' }}</td>
      </tr>
      <tr class="new_type_7">
        <td class="column">第7類型</td>
        <td class="column">{{ existInfo ? info.new_type_7 || 0 : '...' }}</td>
        <td class="column">{{ existInfo ? this.calcInfo.percentage[6] : '...' }}</td>
      </tr>
      <tr class="new_type_8">
        <td class="column">第8類型</td>
        <td class="column">{{ existInfo ? info.new_type_8 || 0 : '...' }}</td>
        <td class="column">{{ existInfo ? this.calcInfo.percentage[7] : '...' }}</td>
      </tr>
      <tr class="new_type_9">
        <td class="column">第9類型</td>
        <td class="column">{{ existInfo ? info.new_type_9 || 0 : '...' }}</td>
        <td class="column">{{ existInfo ? this.calcInfo.percentage[8] : '...' }}</td>
      </tr>
      <tr class="new_type_10">
        <td class="column">第10類型</td>
        <td class="column">{{ existInfo ? info.new_type_10 || 0 : '...' }}</td>
        <td class="column">{{ existInfo ? this.calcInfo.percentage[9] : '...' }}</td>
      </tr>
      <tr class="new_type_11">
        <td class="column">第11類型</td>
        <td class="column">{{ existInfo ? info.new_type_11 || 0 : '...' }}</td>
        <td class="column">{{ existInfo ? this.calcInfo.percentage[10] : '...' }}</td>
      </tr>
      <tr class="new_type_12">
        <td class="column">第12類型</td>
        <td class="column">{{ existInfo ? info.new_type_12 || 0: '...' }}</td>
        <td class="column">{{ existInfo ? this.calcInfo.percentage[11] : '...' }}</td>
      </tr>
      <tr class="new_type_13">
        <td class="column">第13類型</td>
        <td class="column">{{ existInfo ? info.new_type_13 || 0 : '...' }}</td>
        <td class="column">{{ existInfo ? this.calcInfo.percentage[12] : '...' }}</td>
      </tr>
      <tr class="new_type_14">
        <td class="column">第14類型</td>
        <td class="column">{{ existInfo ? info.new_type_14 || 0 : '...' }}</td>
        <td class="column">{{ existInfo ? this.calcInfo.percentage[13] : '...' }}</td>
      </tr>
      <tr class="new_type_15">
        <td class="column">第15類型</td>
        <td class="column">{{ existInfo ? info.new_type_15 || 0 : '...' }}</td>
        <td class="column">{{ existInfo ? this.calcInfo.percentage[14] : '...' }}</td>
      </tr>
      <tr class="new_type_16">
        <td class="column">第16類型</td>
        <td class="column">{{ existInfo ? info.new_type_16 || 0 : '...' }}</td>
        <td class="column">{{ existInfo ? this.calcInfo.percentage[15] : '...' }}</td>
      </tr>
      </tbody>
    </table>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'houseTable',
    props: {
      info: {
        type: Object,
        default: null
      }
    },
    computed: {
      existInfo() {
        return Object.keys(this.info).length > 0 ? true : false
      },
      circleRange () {
        return this.$store.state.circleRange
      },
      calcInfo () {
          let total = 0
          for (var i=1; i<=16; i++) {
            const data = parseInt(this.info["new_type_"+i.toString()])
            total = data ? total + data : total + 0
          }
          let el = []
          for (var i=1; i<=16; i++) {
            let data = parseInt(this.info["new_type_"+i.toString()])
            if (data) {
              el.push(Math.round((data/total)*100).toString())
            }else{
              el.push('0')
            }
          }
          return {
            "total": total,
            "percentage":el
          }
      },
    }
  }
</script>

<style scoped lang="scss">
.new_type_2,
.new_type_4,
.new_type_6,
.new_type_8,
.new_type_10,
.new_type_12,
.new_type_14,
.new_type_16
{
  background: gainsboro;
}

.houseTable tr.column {
  height: 10px;
  background: gainsboro;
}
.houseTable-wrapper {
  margin-top: 20px;
  height: 350px;
  overflow-y: scroll;
}
.houseTable {
  margin: 0px;
  width: 100%
}
</style>

